const employmentTypes = [
	{ key: 'fulltime', value: 'Full-time' },
	{ key: 'parttime', value: 'Part-time' },
	{ key: 'selfemployed', value: 'Self-employed' },
	{ key: 'freelance', value: 'Freelance' },
	{ key: 'internship', value: 'Internship' },
	{ key: 'trainee', value: 'Trainee' }
]

export { employmentTypes }